import { Directive, TemplateRef, Input } from '@angular/core';

@Directive({
    selector: '[headerTemplate]',
    standalone: false
})
class HeaderTemplateDirective {

  constructor(public templateRef: TemplateRef<unknown>) { }

}

@Directive({
    selector: '[subHeaderTemplate]',
    standalone: false
})
class SubHeaderTemplateDirective {

  constructor(public templateRef: TemplateRef<unknown>) { }

}

@Directive({
    selector: '[bodyHeaderTemplate]',
    standalone: false
})
class BodyHeaderTemplateDirective {

  constructor(public templateRef: TemplateRef<unknown>) { }

}

@Directive({
    selector: '[bodyTemplate]',
    standalone: false
})
class BodyTemplateDirective {

  @Input() tabTitle!: string;

  @Input() isActive: boolean = false;

  constructor(public templateRef: TemplateRef<unknown>) { }

}

@Directive({
    selector: '[rightSideTemplate]',
    standalone: false
})
class RightSideTemplateDirective {

  @Input() tabTitle!: string;

  @Input() isActive: boolean = false;

  constructor(public templateRef: TemplateRef<unknown>) { }

}

@Directive({
    selector: '[footerTemplate]',
    standalone: false
})
class FooterTemplateDirective {

  constructor(public templateRef: TemplateRef<unknown>) { }

}

export {
  HeaderTemplateDirective,
  SubHeaderTemplateDirective,
  BodyHeaderTemplateDirective,
  BodyTemplateDirective,
  RightSideTemplateDirective,
  FooterTemplateDirective
}